import * as React from 'react'
import type {SVGProps} from 'react'
const SvgRxBottle = (props: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 48 48" {...props}>
        <g fill="none" fillRule="evenodd" transform="translate(11 11)">
            <path
                fill="#142745"
                fillRule="nonzero"
                d="M21.45 23.4v1.177c0 .786-.728 1.423-1.625 1.423H3.575c-.897 0-1.625-.637-1.625-1.423V7.8h-.336C.723 7.8 0 6.927 0 5.85v-3.9C0 .873.723 0 1.614 0h20.172c.891 0 1.614.873 1.614 1.95v3.9c0 1.077-.723 1.95-1.614 1.95h-.336v2.6q-.669.001-1.3.13V7.8H3.25v16.54c0 .199.18.36.402.36h16.096c.222 0 .402-.161.402-.36v-1.07q.631.129 1.3.13M1.7 1.3c-.22 0-.4.233-.4.52v4.16c0 .287.18.52.4.52h20c.22 0 .4-.233.4-.52V1.82c0-.287-.18-.52-.4-.52z"
            />
            <path
                fill="#142745"
                d="m8.69 13.129 1.157 1.156 1.683-1.683a.505.505 0 1 1 .714.714l-1.683 1.683 1.683 1.684a.505.505 0 1 1-.714.714l-1.683-1.683-1.684 1.683a.505.505 0 1 1-.714-.714l1.683-1.684-1.683-1.683a1 1 0 0 1-.044-.05H6.21v2.007a.505.505 0 0 1-1.01 0v-5.268c0-.141.112-.255.25-.255h2.57c.953 0 1.726.787 1.726 1.758a1.76 1.76 0 0 1-1.056 1.62zm-2.491-.88H8.02a.734.734 0 0 0 .727-.74.734.734 0 0 0-.727-.741H6.199v1.48z"
            />
            <circle cx={21.45} cy={16.9} r={4.55} fill="#FF295B" />
            <path
                fill="#FFF"
                d="M20.86 18.86a.42.42 0 0 1-.303-.129l-1.572-1.6a.44.44 0 0 1 0-.617c.168-.17.44-.17.607 0l1.269 1.29 2.698-2.744a.42.42 0 0 1 .606 0 .44.44 0 0 1 0 .617l-3 3.054a.42.42 0 0 1-.304.128"
            />
        </g>
    </svg>
)
export default SvgRxBottle
